// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.regular-bar[data-v-2bf2b24f] {\n  width: 40vw;\n}\n.overtake-bar[data-v-2bf2b24f] {\n  width: 96%;\n  position: absolute;\n  left: 0px;\n  top: 4px;\n  z-index: 5;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
